import { TreeList } from '@ibsys/kit';
import { TruncatedText } from '@/shared/ui';
import { FileTextIcon, GripVerticalIcon } from 'lucide-react';
import { FC } from 'react';
import { useSortableWhenAllowed } from '@/shared/hooks';
import { cn } from '@/shared/lib';
import type { CompetencyResponse } from '@/entities/coaching';

type LeafNodeProps = {
  competency: CompetencyResponse;
  /** Порядковый номер в списке сортировки */
  index: number;
  onSelect: (id: number) => void;
  /** Право на управление компетенциями: без него узел не перетаскивается */
  canManage: boolean;
};

export const LeafNode: FC<LeafNodeProps> = ({ competency, index, onSelect, canManage }) => {
  const sortableId = `competency-${competency.id}`;
  const { ref, handleRef, isDragging } = useSortableWhenAllowed({ id: sortableId, index }, canManage);

  return (
    <div ref={ref} className={cn(isDragging && 'opacity-50')}>
      <TreeList.Item value={String(competency.id)} onClick={() => onSelect(competency.id)} className="group/leaf">
        <div className="flex items-center gap-2 w-full">
          <FileTextIcon size={14} className="shrink-0 text-muted-foreground" />
          <TruncatedText lines={2} className="flex-1 text-left text-sm font-medium leading-tight">
            {competency.name}
          </TruncatedText>
          {/* Перетаскивание — только при праве на управление */}
          {canManage && (
            <div
              className="shrink-0 cursor-grab text-muted-foreground opacity-0 transition-opacity group-hover/leaf:opacity-100 ml-auto"
              ref={(el) => handleRef(el)}
              onClick={(e) => e.stopPropagation()}
            >
              <GripVerticalIcon size={14} />
            </div>
          )}
        </div>
      </TreeList.Item>
    </div>
  );
};
